import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";
import type { ListParams } from "../components";

export type Site = { id: string; code: string; name: string; kind: string; parent: string | null; timezone: string; is_active: boolean; is_default: boolean; created_at: string };

export function useSites(params: ListParams) {
  return useQuery({
    queryKey: ["sites", params],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/accounts/sites/", { params: { query: params as never } });
      if (error) throw new Error(errorMessage(error));
      return data as unknown as { count: number; results: Site[] };
    },
  });
}

export function useSaveSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }: Partial<Site> & { id?: string }) => {
      const { data, error } = id
        ? await api.PATCH("/api/v1/accounts/sites/{id}/", { params: { path: { id } }, body: body as never })
        : await api.POST("/api/v1/accounts/sites/", { body: body as never });
      if (error) throw error;
      return data as unknown as Site;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["sites"] }),
  });
}

export function useDeleteSite() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await api.DELETE("/api/v1/accounts/sites/{id}/", { params: { path: { id } } });
      if (error) throw new Error(errorMessage(error));
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["sites"] }),
  });
}
